"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapEnableQuickBuyButton = void 0;
var _productBox = require("@ori/product-box");
const mapEnableQuickBuyButton = (labels, shades) => (0, _productBox.mapCanBeSold)(labels) || shades.length > 1 && shades.some(shade => shade.canBeSold) || (0, _productBox.mapHasAutoSubscription)(labels);
exports.mapEnableQuickBuyButton = mapEnableQuickBuyButton;